__webpack_require__.p = "/ec/events/";